import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { AppConfig } from 'src/app/shared/app.config';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UploadDialogComponent } from '../upload-dialog/upload-dialog.component';
import { GenericService } from 'src/app/generic.service';
import { HttpClient, HttpHeaders, HttpRequest, HttpEventType } from '@angular/common/http';
import { FileValidator } from 'ngx-material-file-input';
import { CurrentUser, Inbox } from 'src/app/models';

@Component({
  selector: 'app-attachment-upload-dialog',
  templateUrl: './attachment-upload-dialog.component.html',
  styles: [
  ]
})
export class AttachmentUploadDialogComponent implements OnInit {
  @ViewChild('file')
  hasFile = false;

  fileSelectMsg = 'No file selected yet.';
  progress: number;
  message: string;
  file: File;
  disabled = false;
  uloading = false;
  isFileUploaded = false;
  inboxid: number;
  apiUrl = AppConfig.settings.ApiUrl;
  iForm: FormGroup;
  inbox: Inbox;
  user = new CurrentUser();
  readonly maxSize = 104857600;

  constructor(public dialogRef: MatDialogRef<UploadDialogComponent>, @Inject(MAT_DIALOG_DATA) public ddata: any, private service: GenericService, private http: HttpClient, private formBuilder: FormBuilder) {
    this.user = this.service.getUser();
  }

  get f(): any { return this.iForm.controls; }

  ngOnInit(): void {
    this.inboxid = this.ddata.inboxid;
    this.loadForm();
  }

  loadForm() {
    this.iForm = this.formBuilder.group({
      file: [null, [Validators.required, FileValidator.maxContentSize(this.maxSize)]]
    });
  }

  onFileChange(ev): void {
    this.hasFile = true;
    this.file = ev.target.files[0] as File;
  }

  onSubmit(): void {
    const file = this.file;
    if (file) {
      this.uloading = true;
      const formData = new FormData();
      formData.append(file.name, file);
      // formData.append('userid', this.user.UserId);
      // formData.append('clientid', this.user.ClientId);
      // formData.append('typeid', '6');
      // formData.append('type', 'Email');
      formData.append('inboxid', this.inboxid + '');

      const headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      headers.append('Authorization', `Bearer ${this.service.getToken()}`);

      const uploadReq = new HttpRequest('POST', this.apiUrl + 'Gfile/UploadMsgInboxAttachment/', formData, { headers: headers, reportProgress: true });

      this.http.request(uploadReq).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progress = Math.round((100 * event.loaded) / event.total);
        } else if (event.type === HttpEventType.Response) {
          const res = event.body as any;
          if (res.success === true) {
            this.uloading = false;
            this.service.success('File uploaded successfully!');
            this.isFileUploaded = true;
            this.inbox = res.dto.inbox;
          } else {
            this.uloading = false;
            this.service.error(res.error);
          }
        }
      });
    } else {
      this.service.error('Please select file');
    }
  }

  cancelEvent(): void {
    this.fileSelectMsg = 'No file selected yet.';
    this.hasFile = false;
    this.file = null;
  }


  close(): void {
    this.dialogRef.close(this.inbox);
  }


}
